import React from "react";
import { createRoot } from "react-dom/client";
import { HashRouter } from "react-router-dom";
import { App } from "./App.js";
import { installAudioUnlock } from "./calling/tones.js";
import { installPrivacyGuards } from "./privacy.js";
import { callInProgress } from "./state/call.js";
import { useSession } from "./state/session.js";
import { keyvault } from "./storage/keyvault.js";
import "./ui.css";

// Records when the tab goes hidden, so a fresh app boot can tell "you just
// refreshed" apart from "you actually left for a while" — see
// session.ts's init() for the other half of this.
document.addEventListener("visibilitychange", () => {
  if (document.visibilityState === "hidden") void keyvault.recordHidden();
});

// Opening the app from a notification always asks for the passphrase/passkey
// first (the service worker sends this just before focusing the app). The
// one exception is a call already in progress: locking then would hide the
// hang-up button without making anything more private.
navigator.serviceWorker?.addEventListener("message", (event: MessageEvent<{ type?: string }>) => {
  if (event.data?.type !== "tw-lock") return;
  if (useSession.getState().phase === "ready" && !callInProgress()) useSession.getState().lock();
});

// Leaving the app locks it and hides the chats from the app switcher.
installPrivacyGuards();

// iOS only lets audio start from inside a tap — see tones.ts.
installAudioUnlock();

void useSession.getState().init();

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <HashRouter>
      <App />
    </HashRouter>
  </React.StrictMode>,
);
